'use client';

import { observer } from 'mobx-react-lite';
import { SearchEvent } from 'searchEvent.d';
import {
  SearchListStyle,
  SearchGridColumns,
} from 'components/SearchList/SearchList.css';
import EventCard from '@sympla/sympla-components/EventCard';
import { createPropsToTrackingMatrix } from 'components/Integration/createPropsToTrackingMatrix';
import useLocation from 'hooks/useLocation';
import { useSearchParams } from 'next/navigation';
import { ParamsResult } from 'ParamsResult';
import { useMemo } from 'react';
import { filterParams } from 'components/SearchFilter/filterOptions';
import { cardTypeTrackingSearch, componentTrackingSearch, typeTrackingSearch } from 'constants/search';
import { MATRIX_TYPE } from 'constants/index';

function SearchEventList({
  events,
  serviceParams,
  isMobile,
  tracking,
}: {
  events: SearchEvent[];
  serviceParams?: ParamsResult;
  isMobile: boolean;
  tracking?: {
    label?: string;
    prefix?: string;
    cardType?: string;
    matrizTemplate?: string
  }
}) {
  const locationStore = useLocation();
  const searchParams = useSearchParams();

  const filters = useMemo(() => {
    const state = Object.entries(filterParams).map(([key, content]) => {
      const queryParam = searchParams?.get(content.name) as string | undefined;

      if (!queryParam) return [key, false];
      return [key, queryParam];
    });

    return Object.fromEntries(state);
  }, [searchParams]);

  const getComponentTemplate = () => {
    if (tracking?.label) return tracking?.label;
    if (serviceParams?.url_params?.component?.slug) return serviceParams?.url_params?.component?.slug;
    if (serviceParams?.search_params?.q) return componentTrackingSearch.term;
    return '';
  };

  return (
    <div className={`${SearchListStyle} ${SearchGridColumns.eventList}`} data-testid="search-eventlist-container">
      {events?.map((event, idx) => (
        <EventCard
          key={event.id}
          hasPriority={!idx}
          {...event}
          {...createPropsToTrackingMatrix(idx, {
            type: typeTrackingSearch.event,
            trackingPrefix: tracking?.prefix || MATRIX_TYPE.SEARCH,
            matrizTemplate: tracking?.matrizTemplate || '',
            componentTemplate: getComponentTemplate(),
            dataLocation: locationStore.selectedLocation,
            cardType: tracking?.cardType || cardTypeTrackingSearch.eventCardSearch,
            serviceParams,
            payloadCard: event,
            filters,
          })}
          fullWidth={isMobile}
          layoutCard="lateral-on-mobile"
          data-testid={`search-eventlist-card-${event.id}`}
        />
      ))}
    </div>
  );
}

export default observer(SearchEventList);
